import { WarningsDisplay } from '../../design/warning/warningsDisplay';
import React from 'react';

export const NoDataInfo = () => {
  return (
    <WarningsDisplay
      warnings={[
        [
          'No data is available due to current filter selection. Change focus brand or brand filters',
          { level: 'info' },
        ],
      ]}
    />
  );
};
